export interface ProductPriceSchedulingDTO {
  id?: number;
  token?: string;
  comment?: string;
  productSiteId?: number;
  oldPrice?: number;
  newPrice?: number;
  dateTimeStart?: string;
  status?: ProductPriceSchedulingStatus;
  createdOn?: string;
  statusUpdatedOn?: string;
  createdBy?: string;
  productCode?: string;
  siteNumber?: string;
  failureDetails?: string;
  productDescription?: string;
}

export enum ProductPriceSchedulingStatus {
  DEFINED = 'DEFINED',
  DEFINED_CLIENT = 'DEFINED_CLIENT',
  CHANGED = 'CHANGED',
  INVALID = 'INVALID',
  PENDING_FCC = 'PENDING_FCC',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED'
}
